

// import { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { TextField, Button, Box, Typography, Paper, Alert } from '@mui/material';
// import { useAuth } from './AuthContext'; // Adjust path as needed
// import { validateUserBooking } from './userBookingsValidation'; // Fetch booking data for validation

// const AttendanceForm = () => {
//     const { eventId } = useParams(); // Extract eventId from the URL
//     const { currentUser } = useAuth();
//     const [formData, setFormData] = useState({ name: '', mobile: '', email: '' });
//     const [message, setMessage] = useState(null);
//     const navigate = useNavigate();

//     // Prefill formData with currentUser's details if logged in
//     useEffect(() => {
//         if (currentUser) {
//             setFormData((prev) => ({
//                 ...prev,
//                 email: currentUser.email,
//             }));
//         }
//     }, [currentUser]);

//     const handleChange = (e) => {
//         setFormData({ ...formData, [e.target.name]: e.target.value });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!currentUser) {
//             setMessage("Please log in to mark attendance.");
//             setTimeout(() => setMessage(null), 3000); // Clear message after 3 seconds
//             return;
//         }

//         // Validate user booking with eventId, currentUser's email, and userConfirmed status
//         const isBooked = await validateUserBooking(eventId, currentUser.email);

//         if (isBooked) {
//             setMessage("Attendance marked successfully!");
//             setTimeout(() => setMessage(null), 3000); // Clear message after 3 seconds
//             // Optional: Save attendance data to the database here
//         } else {
//             setMessage("You must have a confirmed booking for this event to mark attendance.");
//             setTimeout(() => {
//                 setMessage(null);
//                 navigate("/home"); // Redirect to home after 3 seconds
//             }, 3000);
//         }
//     };

//     return (
//         <Box 
//             display="flex" 
//             alignItems="center" 
//             justifyContent="center" 
//             minHeight="100vh" 
//             bgcolor="#f4f6f8"
//         >
//             <Paper elevation={3} sx={{ padding: 4, maxWidth: 400, width: '100%' }}>
//                 <Typography variant="h5" component="h1" textAlign="center" gutterBottom>
//                     Mark Your Attendance
//                 </Typography>
//                 <Typography variant="body2" color="textSecondary" textAlign="center" mb={2}>
//                     Event ID: {eventId}
//                 </Typography>
//                 {message && (
//                     <Alert severity="info" sx={{ mb: 2 }}>
//                         {message}
//                     </Alert>
//                 )}
//                 <form onSubmit={handleSubmit} noValidate>
//                     <TextField 
//                         label="Name" 
//                         name="name" 
//                         value={formData.name} 
//                         onChange={handleChange} 
//                         required 
//                         fullWidth 
//                         margin="normal" 
//                         variant="outlined"
//                     />
//                     <TextField 
//                         label="Mobile" 
//                         name="mobile" 
//                         value={formData.mobile} 
//                         onChange={handleChange} 
//                         required 
//                         fullWidth 
//                         margin="normal" 
//                         variant="outlined"
//                     />
//                     <TextField 
//                         label="Email" 
//                         name="email" 
//                         value={formData.email} 
//                         onChange={handleChange} 
//                         required 
//                         fullWidth 
//                         margin="normal" 
//                         variant="outlined"
//                         disabled // Lock the email field to prevent changes
//                     />
//                     <Box display="flex" justifyContent="center" mt={3}>
//                         <Button type="submit" variant="contained" color="primary" fullWidth>
//                             Mark Attendance
//                         </Button>
//                     </Box>
//                 </form>
//             </Paper>
//         </Box>
//     );
// };

// export default AttendanceForm;




import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TextField, Button, Box, Typography, Paper, Alert } from '@mui/material';
import { useAuth } from './AuthContext'; // Adjust path as needed
import { validateUserBooking } from './userBookingsValidation'; // Fetch booking data for validation
import { collection, addDoc } from 'firebase/firestore';
import { firestore } from './firebase'; // Import the Firestore instance from firebase.js

const AttendanceForm = () => {
    const { eventId } = useParams(); // Extract eventId from the URL
    const { currentUser } = useAuth();
    const [formData, setFormData] = useState({ name: '', mobile: '', email: '' });
    const [message, setMessage] = useState(null);
    const navigate = useNavigate();

    // Prefill formData with currentUser's details if logged in
    useEffect(() => {
        if (currentUser) {
            setFormData((prev) => ({
                ...prev,
                email: currentUser.email,
            }));
        }
    }, [currentUser]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!currentUser) {
            setMessage("Please log in to mark attendance.");
            // setTimeout(() => setMessage(null), 3000); // Clear message after 3 seconds
            return;
        }

        // Validate user booking with eventId, currentUser's email, and userConfirmed status
        const isBooked = await validateUserBooking(eventId, currentUser.email);

        if (isBooked) {
            try {
                // Save attendance data to Firestore
                await addDoc(collection(firestore, "attendance"), {
                    eventId: eventId,
                    name: formData.name,
                    mobile: formData.mobile,
                    email: formData.email,
                    timestamp: new Date() // Add timestamp if needed
                });

                setMessage("Attendance marked successfully!");
                // setTimeout(() => setMessage(null), 3000); // Clear message after 3 seconds
            } catch (error) {
                console.error("Error adding attendance record: ", error);
                setMessage("Failed to mark attendance. Please try again.");
                // setTimeout(() => setMessage(null), 3000);
            }
        } else {
            setMessage("You must have a confirmed booking for this event to mark attendance.");
            // setTimeout(() => {
            //     setMessage(null);
            //     navigate("/home"); // Redirect to home after 3 seconds
            // }, 3000);
        }
    };

    return (
        <Box 
            display="flex" 
            alignItems="center" 
            justifyContent="center" 
            minHeight="100vh" 
            bgcolor="#f4f6f8"
        >
            <Paper elevation={3} sx={{ padding: 4, maxWidth: 400, width: '100%' }}>
                <Typography variant="h5" component="h1" textAlign="center" gutterBottom>
                    Mark Your Attendance
                </Typography>
                <Typography variant="body2" color="textSecondary" textAlign="center" mb={2}>
                    Event ID: {eventId}
                </Typography>
                {message && (
                    <Alert severity="info" sx={{ mb: 2 }}>
                        {message}
                    </Alert>
                )}
                <form onSubmit={handleSubmit} noValidate>
                    <TextField 
                        label="Name" 
                        name="name" 
                        value={formData.name} 
                        onChange={handleChange} 
                        required 
                        fullWidth 
                        margin="normal" 
                        variant="outlined"
                    />
                    <TextField 
                        label="Mobile" 
                        name="mobile" 
                        value={formData.mobile} 
                        onChange={handleChange} 
                        required 
                        fullWidth 
                        margin="normal" 
                        variant="outlined"
                    />
                    <TextField 
                        label="Email" 
                        name="email" 
                        value={formData.email} 
                        onChange={handleChange} 
                        required 
                        fullWidth 
                        margin="normal" 
                        variant="outlined"
                        disabled // Lock the email field to prevent changes
                    />
                    <Box display="flex" justifyContent="center" mt={3}>
                        <Button type="submit" variant="contained" color="primary" fullWidth>
                            Mark Attendance
                        </Button>
                    </Box>
                </form>
            </Paper>
        </Box>
    );
};

export default AttendanceForm;
